import Modal from "src/components/common/modal";
import { onlyUnique, Select } from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function FilterForm({
    closeIt, setCurrentPage,
    curFilter, setFilter, usersListMap, 
    userList, defaultFilter
}){
    return (
        <Modal
            touchOutsideClose = {true}
            closeIt = {closeIt}
            title = "Filter"
            width = {"60%"}
        >
            <div className = "m-3">
                <label className = "inline mr-3 font-weight-bold" htmlFor = "void">Validity:</label>
                <select className = "form-control inline" id = "void" value = {curFilter.void} onChange = {e => setFilter({...curFilter, void: e.currentTarget.value})}>
                    <option value = "">Valid</option>
                    <option value = "yes">Void</option>
                    <option>All</option>
                </select>
                {
                curFilter.void?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, void: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <label className = "inline mr-3 font-weight-bold" htmlFor = "projectName">Project Name:</label>
                <input
                    id = "projectName"
                    type = "text"
                    className = "form-control inline"
                    value = {curFilter.projectName}
                    onChange = {e => {
                        setFilter({...curFilter, projectName: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.projectName !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, projectName: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <label className = "inline mr-3 font-weight-bold">Start Date:</label>
                <label className = "inline mr-3" htmlFor = "startDateMin">min:</label>
                <input
                    id = "startDateMin"
                    type = "date"
                    min = "1900-01-01"
                    max = {curFilter.startDateMax || "2999-12-31"}
                    className = "mr-3 form-control"
                    value = {curFilter.startDateMin}
                    onChange = {e => {
                        setFilter({...curFilter, startDateMin: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <label className = "inline mr-3" htmlFor = "startDateMax">max:</label>
                <input
                    id = "startDateMax"
                    type = "date"
                    min = {curFilter.startDateMin || "1900-01-01"}
                    max = "2999-12-31"
                    className = "form-control"
                    value = {curFilter.startDateMax}
                    onChange = {e => {
                        setFilter({...curFilter, startDateMax: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.startDateMax || curFilter.startDateMin?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, startDateMin: "", startDateMax: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <label className = "inline mr-3 font-weight-bold">End Date:</label>
                <label className = "inline mr-3" htmlFor = "endDateMin">min:</label>
                <input
                    id = "endDateMin"
                    type = "date"
                    min = "1900-01-01"
                    max = {curFilter.endDateMax || "2999-12-31"}
                    className = "mr-3 form-control"
                    value = {curFilter.endDateMin}
                    onChange = {e => {
                        setFilter({...curFilter, endDateMin: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <label className = "inline mr-3" htmlFor = "endDateMax">max:</label>
                <input
                    id = "endDateMax"
                    type = "date"
                    min = {curFilter.endDateMin || "1900-01-01"}
                    max = "2999-12-31"
                    className = "form-control"
                    value = {curFilter.endDateMax}
                    onChange = {e => {
                        setFilter({...curFilter, endDateMax: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.endDateMax || curFilter.endDateMin?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, endDateMin: "", endDateMax: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <label className = "inline mr-3 font-weight-bold"># of Potholes:</label>
                <label className = "inline mr-3" htmlFor = "potholeMin">min:</label>
                <input
                    id = "potholeMin"
                    type = "number"
                    max = {curFilter.potholeMax}
                    className = "mr-3 form-control"
                    value = {curFilter.potholeMin}
                    onChange = {e => {
                        setFilter({...curFilter, potholeMin: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <label className = "inline mr-3" htmlFor = "potholeMax">max:</label>
                <input
                    id = "potholeMax"
                    type = "number"
                    min = {curFilter.potholeMin}
                    className = "form-control"
                    value = {curFilter.potholeMax}
                    onChange = {e => {
                        setFilter({...curFilter, potholeMax: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.potholeMin || curFilter.potholeMax?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, potholeMin: "", potholeMax: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <label className = "inline mr-3 font-weight-bold"># of EPs:</label>
                <label className = "inline mr-3" htmlFor = "epMin">min:</label>
                <input
                    id = "epMin"
                    type = "number"
                    max = {curFilter.epMax}
                    className = "mr-3 form-control"
                    value = {curFilter.epMin}
                    onChange = {e => {
                        setFilter({...curFilter, epMin: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <label className = "inline mr-3" htmlFor = "epMax">max:</label>
                <input
                    id = "epMax"
                    type = "number"
                    min = {curFilter.epMin}
                    className = "form-control"
                    value = {curFilter.epMax}
                    onChange = {e => {
                        setFilter({...curFilter, epMax: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.epMin || curFilter.epMax?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, epMin: "", epMax: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <label className = "inline mr-3 font-weight-bold"># of Manholes:</label>
                <label className = "inline mr-3" htmlFor = "manholeMin">min:</label>
                <input
                    id = "manholeMin"
                    type = "number"
                    max = {curFilter.manholeMax}
                    className = "mr-3 form-control"
                    value = {curFilter.manholeMin}
                    onChange = {e => {
                        setFilter({...curFilter, manholeMin: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <label className = "inline mr-3" htmlFor = "manholeMax">max:</label>
                <input
                    id = "manholeMax"
                    type = "number"
                    min = {curFilter.manholeMin}
                    className = "form-control"
                    value = {curFilter.manholeMax}
                    onChange = {e => {
                        setFilter({...curFilter, manholeMax: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.manholeMin || curFilter.manholeMax?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, manholeMin: "", manholeMax: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <label className = "inline mr-3 font-weight-bold" htmlFor = "code">Code:</label>
                <input
                    id = "code"
                    type = "text"
                    className = "form-control inline"
                    value = {curFilter.code}
                    onChange = {e => {
                        setFilter({...curFilter, code: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.code !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, code: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <label className = "inline mr-3 font-weight-bold" htmlFor = "priority">Priority:</label>
                <select
                    id = "priority"
                    className = "form-control inline"
                    value = {curFilter.priority}
                    onChange = {e => {
                        setFilter({...curFilter, priority: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                >
                    <option value = "">Select</option>
                    <option>Low</option>
                    <option>Medium</option>
                    <option>High</option>
                </select>
                {
                curFilter.priority?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, priority: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <label className = "inline mr-3 font-weight-bold" htmlFor = "pending">Pending:</label>
                <select
                    id = "pending"
                    className = "form-control inline"
                    value = {curFilter.pending}
                    onChange = {e => {
                        setFilter({...curFilter, pending: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                >
                    <option value = "All">Select</option>
                    <option value = "">No</option>
                    <option>Yes</option>
                </select>
                {
                curFilter.pending !== "All"?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, pending: "All"})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <label className = "inline mr-3 font-weight-bold" htmlFor = "sup">Supplementary Report:</label>
                <select
                    id = "sup"
                    className = "form-control inline"
                    value = {curFilter.sup}
                    onChange = {e => {
                        setFilter({...curFilter, sup: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                >
                    <option value = "All">Select</option>
                    <option value = "">No</option>
                    <option>Yes</option>
                </select>
                {
                curFilter.sup !== "All"?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, sup: "All"})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <label className = "inline mr-3 font-weight-bold" htmlFor = "hasFile">Has File:</label>
                <select
                    id = "hasFile"
                    className = "form-control inline"
                    value = {curFilter.hasFile}
                    onChange = {e => {
                        setFilter({...curFilter, hasFile: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                >
                    <option value = "">Select</option>
                    <option>Yes</option>
                    <option>No</option>
                </select>
                {
                curFilter.hasFile?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, hasFile: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <label className = "inline mr-3 font-weight-bold" htmlFor = "reportTechEmail">Report Tech:</label>
                <select
                    id = "reportTechEmail"
                    type = "text"
                    className = "form-control inline"
                    value = {curFilter.reportTechEmail}
                    onChange = {e => {
                        setFilter({...curFilter, reportTechEmail: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                >
                    <option value = "">Select</option>
                    {userList.map(u => u.reportTechEmail).filter(onlyUnique).map((v, vi) => 
                    <option key = {vi} value = {v}>
                        {usersListMap[v]}
                    </option>)}
                </select>
                {
                curFilter.reportTechEmail !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, reportTechEmail: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3" style = {{display: "flex", alignItems: "center"}}>
                <div className = "mr-3 font-weight-bold">Status:</div>
                <Select
                    styles = {{
                        control: provided => ({
                          ...provided
                        }),
                      }}
                    className = "inline"
                    isMulti = {true}
                    options = {["Created", "Saved" , "Submitted", "Approved", "Rejected"].map(item => ({label: item, value: item}))}
                    value = {curFilter.status}
                    onChange = {e => {
                        if(e.length === 0){
                            setFilter({...curFilter, status: ""});
                        }else{
                            setFilter({...curFilter, status: e});
                        }
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.status?
                <div style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, status: ""})}}>❌</div>:
                null
                }
            </div>
            <div className = "m-3">
                <label className = "inline mr-3 font-weight-bold" htmlFor = "notes">Notes:</label>
                <input
                    id = "notes"
                    type = "text"
                    className = "form-control inline"
                    value = {curFilter.notes}
                    onChange = {e => {
                        setFilter({...curFilter, notes: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.notes !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, notes: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <label className = "inline mr-3 font-weight-bold" htmlFor = "projectManagerEmail">Approver:</label>
                <select
                    id = "projectManagerEmail"
                    type = "text"
                    className = "form-control inline"
                    value = {curFilter.projectManagerEmail}
                    onChange = {e => {
                        setFilter({...curFilter, projectManagerEmail: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                >
                    <option value = "">Select</option>
                    {userList.map(u => u.projectManagerEmail).filter(onlyUnique).map((v, vi) => 
                    <option key = {vi} value = {v}>
                        {usersListMap[v]}
                    </option>)}
                </select>
                {
                curFilter.projectManagerEmail !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, projectManagerEmail: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <label className = "inline mr-3 font-weight-bold" htmlFor = "approverNotes">Approver Notes:</label>
                <input
                    id = "approverNotes"
                    type = "text"
                    className = "form-control inline"
                    value = {curFilter.approverNotes}
                    onChange = {e => {
                        setFilter({...curFilter, approverNotes: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.approverNotes !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, approverNotes: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <label className = "inline mr-3 font-weight-bold" htmlFor = "createdBy">
                    Created By:
                </label>
                <select
                    id = "createdBy"
                    className = "form-control"
                    onChange = {e => {
                        setFilter({...curFilter, createdBy: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                    value = {curFilter.createdBy}
                >
                    <option value = "">Select</option>
                    {userList.map(u => u.submitterEmail).filter(onlyUnique).map((v, vi) => 
                    <option key = {vi} value = {v}>
                        {usersListMap[v]}
                    </option>)}
                </select>
                {
                curFilter.createdBy?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, createdBy: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <label className = "inline mr-3 font-weight-bold">Submit Time:</label>
                <label className = "inline mr-3" htmlFor = "submitTimeMin">min:</label>
                <input
                    id = "submitTimeMin"
                    type = "date"
                    min = "1900-01-01"
                    max = {curFilter.submitTimeMax || "2999-12-31"}
                    className = "mr-3 form-control"
                    value = {curFilter.submitTimeMin}
                    onChange = {e => {
                        setFilter({...curFilter, submitTimeMin: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <label className = "inline mr-3" htmlFor = "submitTimeMax">max:</label>
                <input
                    id = "submitTimeMax"
                    type = "date"
                    min = {curFilter.submitTimeMin || "1900-01-01"}
                    max = "2999-12-31"
                    className = "form-control"
                    value = {curFilter.submitTimeMax}
                    onChange = {e => {
                        setFilter({...curFilter, submitTimeMax: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.submitTimeMax || curFilter.submitTimeMin?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, submitTimeMin: "", submitTimeMax: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <label className = "inline mr-3 font-weight-bold" htmlFor = "updatedBy">
                    Updated By:
                </label>
                <select
                    id = "updatedBy"
                    className = "form-control"
                    value = {curFilter.updatedBy}
                    onChange = {e => {
                        setFilter({...curFilter, updatedBy: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                >
                    <option value = "">Select</option>
                    {userList.map(u => u.updaterEmail).filter(onlyUnique).map((v, vi) => 
                    <option key = {vi} value = {v}>
                        {usersListMap[v]}
                    </option>)}
                </select>
                {
                curFilter.updatedBy?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, updatedBy: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <label className = "inline mr-3 font-weight-bold">Update Time:</label>
                <label className = "inline mr-3" htmlFor = "updateTimeMin">min:</label>
                <input
                    id = "updateTimeMin"
                    type = "date"
                    min = "1900-01-01"
                    max =  {curFilter.updateTimeMax || "2999-12-31"}
                    className = "mr-3 form-control"
                    value = {curFilter.updateTimeMin}
                    onChange = {e => {
                        setFilter({...curFilter, updateTimeMin: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <label className = "inline mr-3" htmlFor = "updateTimeMax">max:</label>
                <input
                    id = "updateTimeMax"
                    type = "date"
                    min = {curFilter.updateTimeMin || "1900-01-01"}
                    max = "2999-12-31"
                    className = "form-control"
                    value = {curFilter.updateTimeMax}
                    onChange = {e => {
                        setFilter({...curFilter, updateTimeMax: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.updateTimeMax || curFilter.updateTimeMin?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, updateTimeMin: "", updateTimeMax: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "mt-5 mb-3">
                <span className = "btn btn-secondary" onClick = {() => {
                    setFilter(defaultFilter);
                    setCurrentPage(1);
                }}>Clear Filter</span>
            </div>
        </Modal>
    )
}